import { render } from "./LoginCognito.vue?vue&type=template&id=15862b69"
import script from "./LoginCognito.vue?vue&type=script&lang=js"
export * from "./LoginCognito.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__